import { LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import { LocationData } from 'src/shared/LocationData.types';
import {
  AnchorTargetParams,
  AnimalIcon,
  DynamicPlaceholderParams,
  ImagePropertiesParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C24LocationCardProps = RenderingProps<C24LocationCardFields, C24LocationCardParams>;

export type C24LocationCardFields = {
  Location?: LocationData;
  FirstCTA?: LinkField;
  SecondCTA?: LinkField;
  AnimalIcon?: AnimalIcon;
};

export type C24LocationCardParams = {
  DisplayImageOverlay?: string;
  FirstCTAStyle?: string;
  SecondCTAStyle?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams &
  ImagePropertiesParams;
